(() => {
  if (customElements.get('snf-new-dtf')) return;
  class SnfNewDtf extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      const host = document.querySelector('.snfw .snfw-hero-copy');
      const hero = host?.closest('.snfw-hero');
      const counter = hero?.querySelector('.snfw-volume-proof');
      if (!counter) return;
      this.started = true;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.busy = false;
      this.stopped = false;
      this.cardCount = 2;
      this.abort = new AbortController();
      this.stage = this.querySelector('.snf-new-dtf-stage');
      this.stageRoot = this.stage.shadowRoot || this.stage.attachShadow({mode:'open'});
      const cardStyles = document.createElement('style');
      cardStyles.textContent = `
        :host{display:block;min-width:0;min-height:0}
        *,*::before,*::after{box-sizing:border-box}
        .snf-new-dtf-layer{position:absolute;inset:0;width:100%;height:100%;padding:3px 3px 0;min-height:0;display:grid;grid-template-columns:repeat(${this.cardCount},minmax(0,1fr));grid-template-rows:minmax(0,1fr);gap:14px;opacity:0;transition:opacity 650ms ease;pointer-events:none}
        .snf-new-dtf-layer.is-active{opacity:1;pointer-events:auto}
        .snf-new-dtf-card{position:relative;display:grid;grid-template-rows:minmax(0,1fr) 36px;width:100%;height:100%;padding:3px 3px 1px;min-width:0;min-height:0;overflow:hidden;color:#fff;text-decoration:none;font-family:Arial,Helvetica,sans-serif;background:#000;border:2px solid #000;border-radius:10px;box-shadow:0 2px 3px rgb(42 30 16 / 8%);transition:border-color 180ms ease,box-shadow 180ms ease}
        .snf-new-dtf-card:hover{border-color:#000;box-shadow:0 2px 4px rgb(42 30 16 / 14%)}
        .snf-new-dtf-image{display:block;position:static;width:100%;height:100%;min-width:0;min-height:0;max-width:100%;max-height:100%;object-fit:contain;object-position:center;background:#000;border:0;border-radius:5px;margin:0;padding:1px;box-shadow:none;transform:none}
        .snf-new-dtf-category{display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;height:36px;min-width:0;overflow:hidden;white-space:normal;font-size:13px;font-weight:700;line-height:16px;letter-spacing:0;text-align:center;color:#fff;padding:2px 3px 0}
        .snf-new-dtf-card:focus-visible{outline:2px solid #af1018;outline-offset:-2px}
        @media(max-width:900px){.snf-new-dtf-layer{gap:10px}.snf-new-dtf-category{font-size:12px}}
        @media(prefers-reduced-motion:reduce){.snf-new-dtf-layer{transition:none}}
      `;
      this.stageRoot.append(cardStyles);
      this.toggle = this.querySelector('.snf-new-dtf-toggle');
      this.previousButton = this.querySelector('.snf-new-dtf-previous');
      this.nextButton = this.querySelector('.snf-new-dtf-next');
      this.history = [];
      this.historyIndex = -1;
      this.categoryUse = new Map();
      this.productUse = new Map();
      this.productOrder = new Map();
      this.current = [];
      try { this.pools = JSON.parse(this.querySelector('[data-snf-categories]').textContent).filter(p => p.handle && Array.isArray(p.products)); }
      catch { return; }
      const serverNow = Math.max(0,...this.pools.map(p=>Number(p.as_of)||0));
      this.clockOffset = serverNow ? serverNow*1000-Date.now() : 0;
      this.pools.forEach(p => { p.order=Math.random(); this.normalize(p); });
      this.host = host;
      this.counter = counter;
      this.art = hero.querySelector('.snfw-hero-art');
      const trust = host.querySelector('.snfw-trust');
      const banner = this.art?.querySelector('.snfw-same-day-banner');
      this.anchor = counter;
      if (trust && banner) {
        const number = counter.querySelector('.snfw-square-inches-number');
        if (number && !counter.querySelector('.snf-volume-total')) {
          const total = document.createElement('span');
          total.className = 'snf-volume-total';
          total.textContent = counter.firstChild.textContent.replace(/\s*-\s*$/, '');
          const area = document.createElement('span');
          area.className = 'snf-volume-area';
          area.append(...Array.from(counter.childNodes).slice(1));
          counter.replaceChildren(total,area);
        }
        banner.append(counter);
        banner.classList.add('snf-with-volume');
        this.anchor = host.querySelector('.btn-row') || trust;
      }
      this.anchor.after(this);
      this.hidden = true;
      this.setAttribute('role', 'region');
      this.setAttribute('aria-label', this.dataset.label);
      this.layout();
      this.observer = new ResizeObserver(() => this.layout());
      this.observer.observe(host);
      this.observer.observe(this.anchor);
      if (this.art) this.observer.observe(this.art);
      this.toggle.addEventListener('click', () => { this.paused = !this.paused; this.syncButton(); }, {signal:this.abort.signal});
      this.previousButton?.addEventListener('click', () => this.navigate(-1), {signal:this.abort.signal});
      this.nextButton?.addEventListener('click', () => this.navigate(1), {signal:this.abort.signal});
      this.motion.addEventListener('change', () => { this.paused = this.motion.matches; this.syncButton(); }, {signal:this.abort.signal});
      this.syncButton();
      this.showNext();
      this.timer = setInterval(() => {
        if (!this.paused && !document.hidden && !this.matches(':hover') && !this.contains(document.activeElement) && !this.stageRoot.activeElement) this.showNext();
      }, 5000);
      this.refresh();
    }
    disconnectedCallback() {
      if (this.isConnected) return;
      clearInterval(this.timer);
      this.observer?.disconnect();
      this.abort?.abort();
      this.stopped = true;
    }
    normalize(pool) {
      const seen = new Set();
      const now = (Date.now()+this.clockOffset)/1000;
      const cutoff = now-30*24*60*60;
      pool.products = pool.products.filter(p => {
        const published=Number(p.published);
        if (!p.image || !p.url || seen.has(p.id) || !Number.isFinite(published) || published<cutoff || published>now) return false;
        if (!this.productOrder.has(p.id)) this.productOrder.set(p.id,Math.random());
        seen.add(p.id); return true;
      });
    }
    layout() {
      const cs = getComputedStyle(this.host);
      const hostBox = this.host.getBoundingClientRect();
      const top = this.anchor.getBoundingClientRect().bottom - hostBox.top + 18;
      const artBox = this.art?.getBoundingClientRect();
      const besideArt = artBox && artBox.left >= hostBox.right-1;
      const bottom = besideArt ? Math.min(artBox.bottom,hostBox.bottom) : hostBox.bottom;
      const room = bottom - hostBox.top - top;
      this.style.setProperty('--snf-new-left', cs.paddingLeft);
      this.style.setProperty('--snf-new-right', cs.paddingRight);
      this.style.setProperty('--snf-new-top', `${top}px`);
      this.style.setProperty('--snf-new-height', `${Math.max(0,room)}px`);
      this.dataset.room = String(Math.round(room));
    }
    syncButton() {
      this.toggle.textContent = this.paused ? '▶' : 'Ⅱ';
      this.toggle.setAttribute('aria-label', this.paused ? this.dataset.play : this.dataset.pause);
      this.toggle.title = this.toggle.getAttribute('aria-label');
      if (this.previousButton) this.previousButton.disabled = this.busy || this.historyIndex < 1;
      if (this.nextButton) this.nextButton.disabled = this.busy;
    }
    navigate(direction) {
      if (this.busy || this.stopped) return;
      this.paused = true;
      this.syncButton();
      if (direction < 0 && this.historyIndex > 0) this.showSet(this.history[this.historyIndex-1], this.historyIndex-1);
      else if (direction > 0) this.showNext();
    }
    select() {
      this.pools.forEach(p=>this.normalize(p));
      const selected = [];
      const ids = new Set();
      const images = new Set();
      const pools = [...this.pools].filter(p => p.products.length).sort((a,b) =>
        (this.categoryUse.get(a.handle)||0)-(this.categoryUse.get(b.handle)||0) || a.order-b.order);
      for (const pool of pools) {
        const candidates = [...pool.products].sort((a,b) =>
          (this.productUse.get(a.id)||0)-(this.productUse.get(b.id)||0) || this.productOrder.get(a.id)-this.productOrder.get(b.id));
        const product = candidates.find(p => !ids.has(p.id) && !images.has(p.image) && !this.current.some(c => c.product.id===p.id)) || candidates.find(p => !ids.has(p.id) && !images.has(p.image));
        if (!product) continue;
        selected.push({pool,product}); ids.add(product.id); images.add(product.image);
        if (selected.length===this.cardCount) return selected;
      }
      return [];
    }
    async showNext() {
      if (this.busy || this.stopped) return;
      if (this.historyIndex < this.history.length-1) return this.showSet(this.history[this.historyIndex+1], this.historyIndex+1);
      const selected = this.select();
      if (selected.length!==this.cardCount) { this.hidden=true; return; }
      return this.showSet(selected);
    }
    async showSet(selected, historyIndex = null) {
      if (this.busy || this.stopped || selected.length!==this.cardCount) return;
      this.busy = true;
      this.syncButton();
      const layer = document.createElement('div'); layer.className='snf-new-dtf-layer'; layer.inert=true;
      const images=[];
      selected.forEach(({pool,product}) => {
        const card=document.createElement('a'); card.className='snf-new-dtf-card'; card.href=product.url; card.title=product.title; card.dataset.product=String(product.id); card.dataset.category=pool.handle;
        const img=new Image(); img.className='snf-new-dtf-image'; img.alt=product.title; img.width=420; img.height=420; img.decoding='async';
        const label=document.createElement('span'); label.className='snf-new-dtf-category'; label.textContent=pool.title; label.title=pool.title;
        const ready=new Promise(resolve => {
          const timeout=setTimeout(() => resolve(false),10000);
          img.onload=()=>{clearTimeout(timeout);resolve(true)};
          img.onerror=()=>{clearTimeout(timeout);resolve(false)};
        });
        img.src=product.image; images.push(ready); card.append(img,label); layer.append(card);
      });
      const loaded=await Promise.all(images);
      if (this.stopped) { this.busy=false; return; }
      if (loaded.some(v=>!v)) {
        selected.forEach(({pool,product},i)=>{if(!loaded[i])pool.products=pool.products.filter(p=>p.id!==product.id)});
        this.busy=false; this.syncButton(); return;
      }
      const previous=this.stageRoot.querySelector('.is-active');
      this.stageRoot.append(layer);
      this.hidden=false;
      this.layout();
      await new Promise(resolve=>requestAnimationFrame(()=>requestAnimationFrame(resolve)));
      layer.classList.add('is-active'); layer.inert=false;
      if(previous){previous.inert=true;previous.classList.remove('is-active');setTimeout(()=>previous.remove(),700)}
      if (historyIndex === null) {
        selected.forEach(({pool,product})=>{this.categoryUse.set(pool.handle,(this.categoryUse.get(pool.handle)||0)+1);this.productUse.set(product.id,(this.productUse.get(product.id)||0)+1)});
        this.history.push(selected);
        if (this.history.length > 100) this.history.shift();
        this.historyIndex = this.history.length-1;
      } else this.historyIndex = historyIndex;
      this.current=selected;
      this.busy=false;
      this.syncButton();
    }
    async refresh() {
      const queue=[...this.pools];
      const worker=async()=>{
        while(queue.length && !this.stopped){
          const pool=queue.shift();
          try{
            const preview=new URL(location.href).searchParams.get('preview_theme_id');
            const collectionUrl=new URL(pool.url,location.origin);
            let url=new URL(collectionUrl);
            const visited=new Set();
            const collected=[];
            while(url && !this.stopped){
              if(url.origin!==location.origin || url.pathname!==collectionUrl.pathname)break;
              url.searchParams.set('view','snf-new-dtf');url.searchParams.set('sort_by','created-descending');
              if(preview)url.searchParams.set('preview_theme_id',preview);
              if(visited.has(url.href))break;
              visited.add(url.href);
              const response=await fetch(url,{signal:this.abort.signal,credentials:'same-origin'});
              if(!response.ok)break;
              const fresh=await response.json();
              if(fresh.handle!==pool.handle || !Array.isArray(fresh.products))break;
              collected.push(...fresh.products);
              pool.products=[...collected];this.normalize(pool);
              if(this.hidden)this.showNext();
              url=fresh.next?new URL(fresh.next,collectionUrl):null;
            }
          }catch{}
        }
      };
      await Promise.all([worker(),worker(),worker()]);
    }
  }
  customElements.define('snf-new-dtf',SnfNewDtf);
})();
